<template>
  <div class="team-form-page">
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">
        <app-i18n code="home.menu"></app-i18n>
      </el-breadcrumb-item>
      <el-breadcrumb-item :to="{ path: '/team' }">
        <app-i18n code="entities.team.menu"></app-i18n>
      </el-breadcrumb-item>
      <el-breadcrumb-item>
        <app-i18n code="entities.team.edit.title" v-if="isEditing"></app-i18n>
        <app-i18n code="entities.team.new.title" v-if="!isEditing"></app-i18n>
      </el-breadcrumb-item>
    </el-breadcrumb>

    <app-back-button
      route-name="team"
      :i18nCode="`entities.team.label.many`" 
    />

    <h1 class="app-content-title app-content-title--hidden">
      <app-i18n code="entities.team.edit.title" v-if="isEditing"></app-i18n>
      <app-i18n code="entities.team.new.title" v-if="!isEditing"></app-i18n>
    </h1>
    
    <div class="app-content-page">

      <div class="app-page-spinner" v-if="findLoading" v-loading="findLoading"></div>

      <el-form
        :label-position="labelPosition"
        :label-width="labelWidthForm"
        :model="model"
        :rules="rules"
        @submit.native.prevent="doSubmit"
        class="form"
        ref="form"
        v-if="model"
      >
        <el-form-item :label="fields.id.label" :prop="fields.id.name" v-if="isEditing">
          <el-col :lg="11" :md="16" :sm="24">
            <el-input :disabled="true" v-model="model[fields.id.name]" />
          </el-col>
        </el-form-item>

        <el-form-item
          :label="fields.name.label"
          :prop="fields.name.name"
          :required="fields.name.required"
        >
          <el-col :lg="11" :md="16" :sm="24">
            <el-input placeholder="Team A" prefix-icon="icon-teams" ref="focus" v-model="model[fields.name.name]" />
          </el-col>
        </el-form-item>

        <!-- <el-form-item
          :label="fields.logo.label"
          :prop="fields.logo.name"
          :required="fields.logo.required"
        >
          <el-col :lg="11" :md="16" :sm="24">
            <app-image-upload
              :max="fields.logo.max"
              :path="fields.logo.path(currentManage.subproperty.id, teamId)"
              :schema="fields.logo.fileSchema"
              v-model="model[fields.logo.name]"
            ></app-image-upload>
          </el-col>
        </el-form-item> -->

        <!-- program -->
        <el-form-item
          :label="fields.program.label"
          :prop="fields.program.name"
          :required="manageInput.program.required"
        >
          <el-col :lg="11" :md="16" :sm="24">
            <app-autocomplete-one-input
              :disabled="manageInput.program.disabled"
              :fetchFn="fields.program.fetchFn"
              :key="manageInput.program.key"
              :manage="manageInput.program.values"
              v-model="model[fields.program.name]"
              prefix-icon="icon-cup"
            ></app-autocomplete-one-input>
          </el-col>
        </el-form-item>

        <!-- subprogram -->
        <el-form-item
          :label="fields.subprogram.label"
          :prop="fields.subprogram.name"
          :required="manageInput.subprogram.required"
          v-if="model[fields.program.name]"
        >
          <el-col :lg="11" :md="16" :sm="24">
            <app-autocomplete-one-input
              :disabled="manageInput.subprogram.disabled"
              :fetchFn="fields.subprogram.fetchFn"
              :key="manageInput.subprogram.key"
              :manage="manageInput.subprogram.values"
              v-model="model[fields.subprogram.name]"
              prefix-icon="icon-cup"
            ></app-autocomplete-one-input>
          </el-col>
        </el-form-item>

        <el-form-item>
          <div class="form-buttons">
            <el-button
              :disabled="saveLoading"
              @click="doSubmit"
              type="primary"
            >
              <app-i18n v-if="!isEditing" code="common.create"></app-i18n>
              <app-i18n v-if="isEditing" code="common.save"></app-i18n>
            </el-button>

          </div>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import { FormSchema } from '@shared/form/form-schema';
import { TeamModel } from '@modules/team/team-model';
import objectPath from 'object-path';
import Manage from '@shared/manage/manage-model';
import { get } from 'lodash';

const { fields } = TeamModel;
const formSchema = new FormSchema([
  fields.id,
  fields.name,
  // fields.logo,
  fields.program,
  fields.subprogram
]);

export default {
  name: 'app-team-form-page',

  props: ['id'],

  data() {
    return {
      rules: formSchema.rules(),
      teamId: null,
      model: null,
      manageInput: {
        program: {
          key: 0,
          required: true,
          values: { type: 'program' },
        },
        subprogram: {
          key: 0,
          required: true,
          values: { type: 'subprogram' },
        },
      },
    };
  },

  computed: {
    ...mapGetters({
      labelPosition: 'layout/labelPosition',
      labelWidthForm: 'layout/labelWidthForm',
      record: 'team/form/record',
      findLoading: 'team/form/findLoading',
      saveLoading: 'team/form/saveLoading',
      currentManage: 'auth/manage/currentManage',
    }),

    isEditing() {
      return !!this.id;
    },

    fields() {
      return fields;
    },

    teamPrograms() {
      return (programsObject) => {
        if (!programsObject) return [];
        return Object.keys(programsObject).map((id) => ({
          id,
        }));
      };
    },

    teamSubprograms() {
      return (programsObject) => {
        const subprograms = [];

        if (programsObject) {
          Object.values(programsObject).forEach(
            (programObject) => {
              if (!('subprograms' in programObject)) return;
              if (!programObject.subprograms) return;
              subprograms.push(
                ...Object.keys(programObject.subprograms),
              );
            },
          );
        }

        return subprograms.map((id) => ({ id }));
      };
    },
  },

  async created() {
    this.manageInput.program.values = new Manage(
      this.currentManage,
    ).getManageModel();
    this.manageInput.program.key++;

    if (this.isEditing) {
      await this.doFind(this.id);
      this.model = formSchema.initialValues(this.record);
      this._loadModelPerManage(this.record);
    } else {
      this.teamId = await this.doGetNewId(
        this.currentManage,
      );
      await this.doNew(this.currentManage);
      this.model = formSchema.initialValues(this.record);
    }

    // this.model.logo = this.currentManage.property.logos; 
  },

  methods: {
    ...mapActions({
      doGetNewId: 'team/form/doGetNewId',
      doFind: 'team/form/doFind',
      doNew: 'team/form/doNew',
      doUpdate: 'team/form/doUpdate',
      doCreate: 'team/form/doCreate',
    }),

    _loadModelPerManage({ programs }) {
      if (!programs) return;

      if (this.teamPrograms(programs).length === 1) {
        objectPath.set(
          this.manageInput,
          'program.disabled',
          true,
        );
        objectPath.set(
          this.manageInput,
          'subprogram.disabled',
          true,
        );
        objectPath.set(this.model, 'program', {
          id: this.teamPrograms(programs)[0].id,
        });

        if (this.teamSubprograms(programs).length === 1) {
          objectPath.set(
            this.manageInput,
            'subprogram.disabled',
            true,
          );
          objectPath.set(this.model, 'subprogram', {
            id: this.teamSubprograms(programs)[0].id,
          });
        }
      }
    },

    doReset() {
      this.model = formSchema.initialValues(this.record);
    },

    async doSubmit() {
      try {
        await this.$refs.form.validate();
      } catch (error) {
        return;
      }

      this.model.program;
      this.model.subprogram;
      
      const { id, ...values } = formSchema.cast(this.model);
      values.logo = get(this, 'currentManage.subproperty.logo');

      if (this.isEditing) {
        return this.doUpdate({
          id,
          values,
          manage: this.manageInput.subprogram.values,
        });
      } else {
        return this.doCreate({
          id: this.teamId,
          values,
          manage: this.manageInput.subprogram.values,
        });
      }
    },
  },
  watch: {
    'model.program.id'(newId) {
      objectPath.set(
        this.manageInput,
        'program.values.programId',
        newId,
      );
      this.manageInput.subprogram.values = this.manageInput.program.values;
      this.manageInput.subprogram.key += 1;
    },
    'model.subprogram.id'(newId) {
      this.manageInput.subprogram.values.subprogramId = newId;
    },
  },
};
</script>

<style>
</style>
